let nextId = 0;
export default {
  namespaced: true,

  state: {
    notifications: [],
  },

  getters: {
    notifications(state) {
      return state.notifications;
    },
  },

  mutations: {
    PUSH(state, notification) {
      state.notifications.push({
        ...notification,
        id: nextId += 1,
      });
    },

    DELETE(state, notificationToRemove) {
      state.notifications = state.notifications
        .filter((notification) => notification.id !== notificationToRemove.id);
    },
  },

  actions: {
    add({ commit }, notificationToAdd) {
      commit('PUSH', notificationToAdd);
    },
    remove({ commit }, notificationToRemove) {
      commit('DELETE', notificationToRemove);
    },
  },
};
